import React from 'react';
import { makeStyles } from '@material-ui/styles'
import { Typography } from '@material-ui/core'

const useStyles = makeStyles( () => ({
  root: {
    margin: '50px 0'
  },
  noResultsHeading: {
    fontSize: '18px',
    fontWeight: 500
  },
  noResultsDetails: {
    fontSize: '14px'
  }
}));



// Simple styled text grouping
export const Info = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.noResultsHeading}>{props.heading}</Typography>
      <Typography className={classes.noResultsDetails}>{props.details}</Typography>
    </div>
  )
}